// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const GH_PHONE_REGEX = /^\+233 (?!233)\d{8,12}$/;

export function validateGhanaPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim() || !parseInt(phoneNumberValue)) {
    return { id: 'empty' };
  } else if (!GH_PHONE_REGEX.test(phoneNumberValue) || phoneNumberValue.length < 13) {
    return { id: 'invalid-pattern' };
  }
}
